import { omit, get } from 'lodash';

import apolloClient from 'store/apolloClient';
import * as services from 'modules/appointmentsManagement/services/getPatientByExternalId';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';
import { getUserPermissions } from 'modules/appointmentsManagement/selectors/users';
import createAction from './index';

export const APPOINTMENT_USER_CHECK = createAsyncAction(createAction('APPOINTMENT_USER_CHECK'));

export const getPatientByExternalId = (data) => dispatch => {
  dispatch({
    type: APPOINTMENT_USER_CHECK.pending,
    payload: data,
  });

  const apiCallParams = {
    query: services.FETCH_PATIENT_BY_EXTERNAL_ID,
    fetchPolicy: 'no-cache',
    variables: data,
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const user = response.data.getPatientByExternalId;
      const payload = omit({ ...user, ...user.profile }, ['profile', 'dynamicPermissions']);
      const { canSeeDetails } = getUserPermissions(user.dynamicPermissions.roleResources);
      if (!canSeeDetails) {
        payload.externalId = data.externalId;
        payload.isRestrictedUser = true;
      }
      payload.canUpdate = getUserPermissions(user.dynamicPermissions.roleResources, 'update').canSeeDetails;
      payload.note = get(user, 'notesInfo.notes[0].text');

      return dispatch({
        type: APPOINTMENT_USER_CHECK.success,
        payload,
      });
    })
    .catch((err) => {
      dispatch(errorAction(APPOINTMENT_USER_CHECK.failure, err));

      throw err;
    });
};
